import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Woonggi Kim
 * @contact wgkim@detech.co.kr
 * @date 2024-03-14
 * @brief SEI 커뮤니티 관리 개발
 *
 ********************************************************************/
import { useState } from "react";
function CommunityManagementTree(props) {
    // props
    let selTree = props.selTree;
    const [menuList, setMenuList] = useState([
        { menuId: 0, menuName: "커뮤니티 카테고리 관리", typeName: "CATEGORY" },
        { menuId: 1, menuName: "신고 게시글/댓글 관리", typeName: "CLAIM" },
    ]);
    // tree 초기화 - 선택
    /*  useEffect(() => {
       setParentSelTree(menuList[0].adminType, {
         menu: { "menuId": menuList[0].menuId, "menuName": menuList[0].menuName, },
       })
     }, [])
    */
    //
    function onClickGoMenu(e, menu) {
        // e.stopPropagation();
        props.setSelTree(menu.menuId);
    }
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: "box treebar pushy-menutype type3 h-auto" }, { children: _jsx("div", Object.assign({ className: "lnb" }, { children: _jsx("ul", Object.assign({ className: "lnb-depth1" }, { children: menuList.map((menu, idx) => (_jsx("li", Object.assign({ onClick: (e) => onClickGoMenu(e, menu), className: menu.menuId == selTree ? "active" : "" }, { children: _jsx("p", { children: _jsx("a", { children: _jsx("span", { children: menu.menuName }) }) }) }), `menu_${idx.toString()}`))) })) })) })) }));
}
export default CommunityManagementTree;
